export class TeamApiError extends Error {
  constructor(public status: number, message: string) { super(message); }
}

export async function teamApi<T>(url: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(url, { credentials: "same-origin", ...init, headers: { ...(init.body ? { "Content-Type": "application/json" } : {}), ...init.headers } });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new TeamApiError(response.status, body?.error?.message ?? "The request could not be completed.");
  return body as T;
}

const csrf = new Map<"organiser" | "participant", string>();
export async function teamMutation<T>(surface: "organiser" | "participant", url: string, body?: unknown) {
  let token = csrf.get(surface);
  if (!token) {
    token = (await teamApi<{ csrfToken: string }>(`/api/team/${surface}/csrf`)).csrfToken;
    csrf.set(surface, token);
  }
  return teamApi<T>(url, { method: "POST", headers: { "x-csrf-token": token }, ...(body === undefined ? {} : { body: JSON.stringify(body) }) });
}

export function clearTeamApiState() { csrf.clear(); }

export async function teamFileMutation<T>(url: string, file: File) {
  let token = csrf.get("organiser");
  if (!token) {
    token = (await teamApi<{ csrfToken: string }>("/api/team/organiser/csrf")).csrfToken;
    csrf.set("organiser", token);
  }
  return teamApi<T>(url, { method: "POST", body: file, headers: { "Content-Type": file.type, "x-csrf-token": token } });
}
